// The en-US strings loaded eagerly at boot from the shared barrels (shared
// components + shared-enterprise-tools). index.tsx injects these via
// addTranslations before domain registration, and the nav-label manifest gate
// mirrors them to decide which nav ids already resolve without a domain catalog.
// Single source so the boot path and the gate can't drift.
import { SHARED_COMPONENTS_EN_US } from '@retailer-platform/shared-components/src/exports/shared-components-core'
import { SHARED_ENTERPRISE_TOOLS_EN_US } from '@retailer-platform/domain-shared-enterprise-tools/shared-enterprise-tools-core'

export const EAGER_EN_US_CATALOG: Record<string, string> = {
  ...SHARED_COMPONENTS_EN_US,
  ...SHARED_ENTERPRISE_TOOLS_EN_US,
}
